const siteConfig = {
  brandName: "Iuturegarden",
  wordmark: "Iuturegarden",
  logo: null,
  description:
    "Purpose-built Japanese denim and heavyweight clothing, made for the road and designed to age with you.",
  tagline: "Genuine quality. Built to endure.",
  currency: "GBP",
  locale: "en-GB",
  shippingThreshold: 200,
  standardShipping: 7,
  shippingRates: {
    "United Kingdom": { standard: 7, express: 20 },
    "United States": { standard: 22, express: 36 },
    Canada: { standard: 20, express: 34 },
    "European Union": { standard: 16, express: 29 },
    Japan: { standard: 24, express: 38 },
    Australia: { standard: 25, express: 40 },
  },
  contact: {
    email: "shop@iuturegarden.shop",
    phone: "+44 (0)2392 000 241",
    hours: "Monday–Friday, 09:00–17:30 GMT",
    address: ["Cooperage Green", "Gosport, Hampshire", "United Kingdom"],
  },
  social: {
    instagram: "https://www.instagram.com/",
    tiktok: "https://www.tiktok.com/",
  },
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);

export default siteConfig;
